import { Injectable } from "@angular/core";
import { Router, CanActivate, RouterStateSnapshot } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { OrderService } from "../services/order-service";
import { take } from "rxjs/operators";
import * as _ from "lodash";
import { ToastrService } from "../services/toastr.service";


@Injectable()
export class OrderTypeGuard implements CanActivate {
  constructor(private router: Router,public orderService:OrderService , public toastService:ToastrService) { }

   canActivate(route, state: RouterStateSnapshot) {
    // console.log(this.authService.isLoggedIn());.
    const order= this.orderService.getOrderObject()
    if (!_.isNil(order) &&  !_.isNil(order.orderType)){
      return true;       
    }
    this.toastService.error("שגיאה","אנא בחר סוג הזמנה");
    this.router.navigate([""]);
    return false;
  }
}
